<!-- Full screen booking details modal content -->
<ng-template #bookingDetailsModal let-modal>
  <div class="modal-content">
    <div class="modal-header border-bottom justify-content-between align-items-center" id="booking-details-modal-header">
      <div class="d-flex justify-content-between gap-2 flex-wrap align-items-center flex-grow-1" style="min-width: 0">
        <h5 class="modal-title" id="booking-details-title">
          Trip #{{ bookingDetails.uniqueId }}
          @if (bookingDetails?.status != null) {
          <span class="trip-status-pill" id="booking-status-pill" [ngClass]="'tone-' + statusTone(bookingDetails.status)">{{ getStatusString(bookingDetails.status) | translate }}</span>
          }
        </h5>

        @if (getBookingTagsString(bookingDetails?.bookingTags).length > 0) {
        <div class="justify-self-end">
          @for (item of getBookingTagsString(bookingDetails?.bookingTags); track $index) { @if (item) {
          @if(bookingDetails?.bookingTags.includes(helper.BookingType[helper.BookingType.CITY_TO_CITY])) { @if(item.tag == helper.BookingType[helper.BookingType.CITY_TO_CITY]){
          <span
            class="badge bg-theme mb-1 me-1"
            [ngStyle]="{ color: helper.getBookingTagColor(item.tag), 'border-color': helper.getBookingTagColor(item.tag), 'border-width': '1px', 'border-style': 'solid' }"
          >
            {{ item.string }}
          </span>
          } }@else {
          <span
            class="badge bg-theme mb-1 me-1"
            [ngStyle]="{ color: helper.getBookingTagColor(item.tag), 'border-color': helper.getBookingTagColor(item.tag), 'border-width': '1px', 'border-style': 'solid' }"
          >
            {{ item.string }}
          </span>
          } } }
        </div>
        }
      </div>
      <button type="button" class="btn-close flex-shrink-0" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body p-0" [ngClass]="{ 'bg-body': tabType !== 'basicDetails' }">
      <ul ngbNav #Bordered="ngbNav" [(activeId)]="activeTab" class="nav nav-tabs nav-tabs-custom nav-secondary mb-0 thead-sticky pt-3" id="tab-height" style="z-index: 2">
        <li [ngbNavItem]="1">
          <a ngbNavLink (click)="onTabClick('basicDetails')">{{ "label-title.basic-details" | translate }}</a>
          <ng-template ngbNavContent>
            <div class="row booking-details-tab-content-height" style="margin-left: 0; margin-right: 0">
              <div class="col-lg-4 col-md-6 col-12 border-end border-start border-bottom px-0">
                <div class="column-padding py-3">
                  @if (!isDeliveryPickUpBooking()) {
                  <div class="d-flex">
                    <p class="col-6 mb-2">{{ "label-title.type" | translate }}</p>
                    <p class="col-6 mb-2">
                      @if (bookingDetails.vehicleType?.name) {
                      {{ bookingDetails.vehicleType?.name }}
                      } @else {
                      {{ bookingDetails.vehicleTypeNames }}
                      }
                    </p>
                  </div>
                  @if (bookingDetails.customerVehicleDetail) {
                  <div class="d-flex">
                    <p class="col-6 mb-2">{{ "label-title.vehicle" | translate }}</p>
                    <p class="col-6 mb-2">
                      {{ bookingDetails.customerVehicleDetail.name }} | {{ bookingDetails.customerVehicleDetail.plateNo }} | {{ bookingDetails.customerVehicleDetail.color }} |
                      {{ bookingDetails.customerVehicleDetail.brand }} |
                      {{ bookingDetails.customerVehicleDetail.model }}
                    </p>
                  </div>
                  } @if(bookingHistoryMainType !== helper.BookingHistoryMainType.CANCELLED){
                  <div class="d-flex">
                    <p class="col-6 mb-2">{{ "label-title.distance" | translate }}</p>
                    <p class="col-6 mb-2">
                      {{ (getDistance() * (bookingDetails.bookingInvoice?.distanceUnit == helper.DistanceUnit.KM ? 0.001 : 0.000621371)).toFixed(decimalPointValue) }}
                      @if (bookingDetails.bookingInvoice?.distanceUnit == helper.DistanceUnit.KM) {
                      {{ "label-title.km" | translate }}
                      } @if (bookingDetails.bookingInvoice?.distanceUnit == helper.DistanceUnit.MILE) {
                      {{ "label-title.mile" | translate }}
                      }
                    </p>
                  </div>
                  }
                  <div class="d-flex">
                    <p class="col-6 mb-2">{{ "label-title.time" | translate }}</p>
                    @if(bookingHistoryMainType === helper.BookingHistoryMainType.RUNNING && isNotQuickCommerceBooking() && isNotDeliveryBooking()) {
                    <p class="col-6 mb-2">{{ formatTime(bookingTimesDetails?.time) }}</p>
                    } @else {
                    <p class="col-6 mb-2">{{ formatTime(bookingInvoiceDetails?.time) }}</p>
                    }
                  </div>
                  }
                  <!-- show if quick commerce booking -->
                  @if (isQuickCommerceBooking()) {
                  <div class="d-flex">
                    <p class="col-6 mb-2">{{ "label-title.pick-time" | translate }}</p>
                    <p class="col-6 mb-2">{{ formatTime(bookingInvoiceDetails?.pickTime) }}</p>
                  </div>
                  }
                  <!-- show if not quick commerce start -->
                  @if (isNotQuickCommerceBooking() && isNotDeliveryBooking() && isNotServiceBooking()) {
                  <div class="d-flex">
                    <p class="col-6 mb-2">{{ "label-title.wait-time" | translate }} ({{ "label-title.pickup" | translate }})</p>
                    @if (bookingHistoryMainType === helper.BookingHistoryMainType.RUNNING) {
                    <p class="col-6 mb-2">{{ formatTime(bookingTimesDetails?.waitingTime) }}</p>
                    } @else {
                    <p class="col-6 mb-2">{{ formatTime(bookingInvoiceDetails?.waitingTime) }}</p>
                    }
                  </div>
                  }
                  <!-- show if not quick commerce end -->
                  <!-- show if not rental and quick commerce booking start -->
                  @if(isNotRentalBooking() && isNotQuickCommerceBooking() && isNotDeliveryBooking() && isNotServiceBooking()) {
                  <div class="d-flex">
                    <p class="col-6 mb-2">{{ "label-title.stand-by-time" | translate }}</p>
                    <p class="col-6 mb-2">
                      @if (bookingDetails.status < helper.BookingStatus.ARRIVED_AT_STOP) {
                      {{ formatTime(bookingInvoiceDetails?.stopWaitingTime) }}
                      } @else {
                      {{ formatTime(bookingTimesDetails?.stopWaitingTime) }}
                      }
                    </p>
                  </div>
                  <div class="d-flex">
                    <p class="col-6 mb-2">{{ "label-title.traffic-time" | translate }}</p>
                    @if (bookingHistoryMainType === helper.BookingHistoryMainType.RUNNING) {
                    <p class="col-6 mb-2">{{ formatTime(bookingTimesDetails?.trafficTime) }}</p>
                    } @else {
                    <p class="col-6 mb-2">{{ formatTime(bookingInvoiceDetails?.trafficTime) }}</p>
                    }
                  </div>
                  }
                  <!-- show if not rental and quick commerce booking end -->
                  @if ((isNotQuickCommerceBooking() && isNotDeliveryBooking()) || bookingDetails.status < helper.BookingStatus.ARRIVED_AT_DESTINATION) {
                  <div class="d-flex">
                    <p class="col-6 mb-2">
                      @if (isQuickCommerceBooking() || isDeliveryBooking() || isServiceBooking()) {
                      {{ "label-title.price" | translate }}
                      } @else {
                      {{ "label-title.estimated-price" | translate }}
                      }
                    </p>
                    <p class="col-6 mb-2">
                      <span class="d-flex currency-gap">
                        {{ bookingDetails.bookingInvoice?.estimated?.total?.toFixed(decimalPointValue) }}
                        <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                          {{ bookingDetails.bookingInvoice?.currencySign }}
                        </span>
                      </span>
                    </p>
                  </div>
                  } @if (bookingHistoryMainType !== helper.BookingHistoryMainType.SCHEDULED && bookingDetails.status >= helper.BookingStatus.ARRIVED_AT_DESTINATION) {
                  <div class="d-flex">
                    <p class="col-6 mb-0">
                      @if (isQuickCommerceBooking() || isDeliveryBooking() || isServiceBooking()) {
                      {{ "label-title.price" | translate }}
                      } @else {
                      {{ "label-title.actual-price" | translate }}
                      }
                    </p>
                    <p class="col-6 mb-0">
                      <span class="d-flex currency-gap">
                        {{ bookingDetails.bookingInvoice?.actual?.total?.toFixed(decimalPointValue) }}
                        <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                          {{ bookingDetails.bookingInvoice?.currencySign }}
                        </span>
                      </span>
                    </p>
                  </div>
                  } @if (bookingDetails?.biddingDetail?.isBidding) {
                  <div class="d-flex">
                    <p class="col-6 mb-0 mt-2">{{ "label-title.customer-bid-price" | translate }}</p>
                    <p class="col-6 mb-0 mt-2">
                      <span class="d-flex currency-gap">
                        {{ bookingDetails.biddingDetail?.customerBidPrice?.toFixed(decimalPointValue) }}
                        <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                          {{ bookingDetails.bookingInvoice?.currencySign }}
                        </span>
                      </span>
                    </p>
                  </div>
                  <div class="d-flex">
                    <p class="col-6 mb-0 mt-2">{{ "label-title.final-bid-price" | translate }}</p>
                    <p class="col-6 mb-0 mt-2">
                      <span class="d-flex currency-gap">
                        {{ bookingDetails.biddingDetail?.finalBidPrice?.toFixed(decimalPointValue) }}
                        <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                          {{ bookingDetails.bookingInvoice?.currencySign }}
                        </span>
                      </span>
                    </p>
                  </div>
                  }

                  <!-- rental package details start -->
                  @if(isRentalBooking() && (bookingDetails?.packageDetail?.distancePrice.isActive || bookingDetails?.packageDetail?.timePrice.isActive)) {
                  <div class="col-12 mt-2 pt-2 border-top">
                    <h5 class="mb-2">{{ "heading-title.package-details" | translate }} - {{ bookingDetails?.packageDetail?.packageName }}</h5>
                    <div class="">
                      <div class="d-flex">
                        @if(!bookingDetails?.packageDetail.distancePrice.isApplySlotPrice){
                        <p class="me-1 mb-3">
                          {{ bookingDetails?.packageDetail.distancePrice.basePriceUnit }}
                          @if(bookingDetails.bookingInvoice?.distanceUnit === helper.DistanceUnit.KM){
                          {{ "label-title.km" | translate | titlecase }}
                          }@else {
                          {{ "label-title.mile" | translate | titlecase }}
                          }
                        </p>
                        } @if(!bookingDetails?.packageDetail.timePrice.isApplySlotPrice && !bookingDetails?.packageDetail.distancePrice.isApplySlotPrice){
                        <p class="me-1 mb-3">
                          {{ "label-title.and" | translate }}
                        </p>
                        } @if ( !bookingDetails?.packageDetail.timePrice.isApplySlotPrice) {
                        <p class="mb-3">
                          {{ bookingDetails?.packageDetail.timePrice.basePriceUnit }}
                          {{ "label-title.min" | translate | titlecase }}
                        </p>
                        }
                      </div>
                      <div class="mb-3">
                        @if(bookingDetails?.packageDetail.distancePrice.basePrice != 0 || bookingDetails?.packageDetail.distancePrice.isApplySlotPrice){
                        <p class="mb-0 d-flex">
                          {{ "label-title.distance-price" | translate }}
                          @if(!bookingDetails?.packageDetail.distancePrice.isApplySlotPrice){ :
                          <span class="d-flex currency-gap ms-2">
                            {{ bookingDetails?.packageDetail.distancePrice.basePrice.toFixed(decimalPointValue) }}
                            <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                              {{ bookingDetails.bookingInvoice?.currencySign }}
                            </span>
                          </span>
                          }
                        </p>
                        } @if(bookingDetails?.packageDetail.distancePrice.isApplySlotPrice){ @for(slot of bookingDetails?.packageDetail.distancePrice.slots ; track $index){
                        <p class="mb-0 fs-11 d-flex">
                          {{ slot.min }} @if(bookingDetails.bookingInvoice?.distanceUnit === helper.DistanceUnit.KM){
                          {{ "label-title.km" | translate | titlecase }}
                          }@else {
                          {{ "label-title.mile" | translate | titlecase }}
                          } - {{ slot.max === helper.backendMaxInt ? "∞" : slot.max }}
                          @if(bookingDetails.bookingInvoice?.distanceUnit === helper.DistanceUnit.KM){
                          {{ "label-title.km" | translate | titlecase }}
                          }@else {
                          {{ "label-title.mile" | translate | titlecase }}
                          } :
                          <span class="d-flex currency-gap ms-2">
                            {{ slot.price.toFixed(decimalPointValue) }}
                            <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                              {{ bookingDetails.bookingInvoice?.currencySign }}
                            </span>
                          </span>
                        </p>

                        } }@else if(bookingDetails?.packageDetail.distancePrice.unitPrice != 0){
                        <p class="mb-0 fs-11 d-flex">
                          {{ "label-title.extra-distance-charge" | translate }} :
                          <span class="d-flex currency-gap ms-2">
                            {{ bookingDetails?.packageDetail.distancePrice.unitPrice.toFixed(decimalPointValue) }}
                            <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                              {{ bookingDetails.bookingInvoice?.currencySign }}
                            </span>
                          </span>
                          / @if(bookingDetails.bookingInvoice?.distanceUnit === helper.DistanceUnit.KM){
                          {{ "label-title.km" | translate | titlecase }}
                          }@else {
                          {{ "label-title.mile" | translate | titlecase }}
                          }
                        </p>
                        }
                      </div>
                      <div class="">
                        @if(bookingDetails?.packageDetail.timePrice.basePrice != 0 || bookingDetails?.packageDetail.timePrice.isApplySlotPrice){
                        <p class="mb-0 d-flex">
                          {{ "label-title.time-price" | translate }}
                          @if(!bookingDetails?.packageDetail.timePrice.isApplySlotPrice){ :
                          <span class="d-flex currency-gap ms-2">
                            {{ bookingDetails?.packageDetail.timePrice.basePrice.toFixed(decimalPointValue) }}
                            <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                              {{ bookingDetails.bookingInvoice?.currencySign }}
                            </span>
                          </span>
                          }
                        </p>

                        } @if(bookingDetails?.packageDetail.timePrice.isApplySlotPrice){ @for(slot of bookingDetails?.packageDetail.timePrice.slots ; track $index){
                        <p class="mb-0 fs-11 d-flex">
                          {{ slot.min }} {{ "label-title.min" | translate | titlecase }} -
                          {{ slot.max === helper.backendMaxInt ? "∞" : slot.max }}
                          {{ "label-title.min" | translate | titlecase }} :
                          <span class="d-flex currency-gap ms-2">
                            {{ slot.price.toFixed(decimalPointValue) }}
                            <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                              {{ bookingDetails.bookingInvoice?.currencySign }}
                            </span>
                          </span>
                        </p>
                        } }@else if(bookingDetails?.packageDetail.timePrice.unitPrice != 0){
                        <p class="mb-0 fs-11 d-flex">
                          {{ "label-title.extra-time-charge" | translate }} :
                          <span class="d-flex currency-gap ms-2">
                            {{ bookingDetails?.packageDetail.timePrice.unitPrice.toFixed(decimalPointValue) }}
                            <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                              {{ bookingDetails.bookingInvoice?.currencySign }}
                            </span>
                          </span>
                          / {{ "label-title.min" | translate | titlecase }}
                        </p>
                        }
                      </div>
                    </div>
                  </div>
                  }
                  <!-- rental package details end -->

                  <!-- cancellation reason start -->
                  @if (bookingDetails?.cancellationReason) {
                  <div class="d-flex">
                    <p class="col-6 mb-0 mt-2">{{ "label-title.cancellation-reason" | translate }}</p>
                    <p class="col-6 mb-0 mt-2">{{ bookingDetails.cancellationReason }}</p>
                  </div>
                  }
                  <!-- cancellation reason end -->
                </div>

                <!-- verification details start -->
                @if (bookingDetails.verificationDetail?.length > 0) {
                <div class="">
                  <div class="bg-sub-gray d-flex justify-content-between align-items-center py-2 column-padding">
                    <h5 class="mb-0">{{ "heading-title.verification-details" | translate }}</h5>
                  </div>
                  <div class="column-padding py-3">
                    @for (item of bookingDetails.verificationDetail; track $index) { @if (!(isDeliveryPickUpBooking() && item.status === helper.BookingStatus.STARTED)) {
                    <div class="d-flex">
                      <p class="col-6 mb-2">{{ getStatusString(item.status) | translate }}</p>
                      <p class="col-6 mb-2">{{ item.otp }}</p>
                    </div>
                    } }
                  </div>
                </div>
                }
                <!-- verification details end -->

                <!-- customer details start -->
                @if (bookingDetails.customerDetail) {
                <div class="">
                  <div class="bg-sub-gray d-flex justify-content-between align-items-center py-2 column-padding">
                    <h5 class="mb-0 d-flex gap-1">
                      {{ "heading-title.customer-details" | translate }}

                      @if (bookingDetails?.isBookForOther) {
                      <p class="text-muted mb-0">#{{ bookingDetails?.customerDetail?.uniqueId }}</p>
                      }
                    </h5>
                  </div>
                  <div class="column-padding py-3">
                    <div class="d-flex align-items-center mb-3">
                      <div class="flex-shrink-0">
                        <img
                          [src]="bookingDetails.customerDetail.imageUrl ? helper.imageUrl + bookingDetails.customerDetail.imageUrl : helper.DefaultImages.DefaultUserImage"
                          (error)="handleCustomerImageError($event)"
                          alt=""
                          class="avatar-xl rounded material-shadow border"
                        />
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <div class="d-flex flex-wrap mb-2">
                          <h6 class="fs-14 mb-0">{{ bookingDetails.customerDetail.name }}</h6>
                          @if (bookingDetails?.rating?.driverRate) {
                          <div class="badge bg-success mb-0 ms-2" style="height: fit-content"><em class="mdi mdi-star"></em> {{ bookingDetails?.rating?.driverRate }}</div>
                          }
                        </div>
                        @if (!bookingDetails?.isBookForOther) {
                        <p class="text-muted mb-2">#{{ bookingDetails?.customerDetail?.uniqueId }}</p>
                        } @if (bookingDetails?.customerDetail?.email) {
                        <div class="mb-2"><em class="ri-mail-line me-2 align-middle text-muted fs-16"></em>{{ bookingDetails.customerDetail.email }}</div>
                        }
                        <div class="mb-2"><em class="ri-phone-line me-2 align-middle text-muted fs-16"></em>{{ bookingDetails.customerDetail.phone }}</div>
                      </div>
                    </div>

                    <!-- customer corporate details start -->
                    @if (bookingDetails.corporate) {
                    <div class="">
                      <p class="text-muted mb-2">{{ "label-title.corporate-details" | translate }}</p>
                      <h6 class="fs-14 mb-2">{{ bookingDetails.corporate?.firstName }} {{ bookingDetails.corporate?.lastName }}</h6>
                      <p class="text-muted mb-0">{{ bookingDetails.corporate?.email }}</p>
                    </div>
                    }
                    <!-- customer corporate details end -->
                  </div>
                </div>
                }
                <!-- customer details end -->

                <!-- merchant details start -->
                @if (bookingDetails.quickCommerce?.merchantDetail?.id) {
                <div class="">
                  <div class="bg-sub-gray d-flex justify-content-between align-items-center py-2 column-padding">
                    <h5 class="mb-0 d-flex gap-1">
                      {{ "heading-title.merchant-details" | translate }}
                    </h5>
                  </div>
                  <div class="column-padding py-3">
                    <div class="d-flex align-items-center mb-3">
                      <div class="flex-shrink-0">
                        <img
                          [src]="
                            bookingDetails.quickCommerce.merchantDetail.imageUrl
                              ? helper.imageUrl + bookingDetails.quickCommerce.merchantDetail.imageUrl
                              : helper.DefaultImages.DefaultUserImage
                          "
                          (error)="handleMerchantImageError($event)"
                          alt=""
                          class="avatar-xl rounded material-shadow border"
                        />
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <div class="d-flex flex-wrap mb-2">
                          <h6 class="fs-14 mb-0">{{ bookingDetails.quickCommerce.merchantDetail.name }}</h6>
                        </div>
                        <p class="text-muted mb-2">#{{ bookingDetails.quickCommerce.merchantDetail.uniqueId }}</p>
                        @if (bookingDetails.quickCommerce.merchantDetail.email) {
                        <div class="mb-2"><em class="ri-mail-line me-2 align-middle text-muted fs-16"></em>{{ bookingDetails.quickCommerce.merchantDetail.email }}</div>
                        }
                        <div class="mb-2"><em class="ri-phone-line me-2 align-middle text-muted fs-16"></em>{{ bookingDetails.quickCommerce.merchantDetail.phone }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                }
                <!-- merchant details end -->

                <!-- picker details start -->
                @if (bookingDetails.quickCommerce?.confirmedPicker?.id) {
                <div class="">
                  <div class="bg-sub-gray d-flex justify-content-between align-items-center py-2 column-padding">
                    <h5 class="mb-0 d-flex gap-1">
                      {{ "heading-title.picker-details" | translate }}
                    </h5>
                  </div>
                  <div class="column-padding py-3">
                    <div class="d-flex align-items-center mb-3">
                      <div class="flex-shrink-0">
                        <img
                          [src]="
                            bookingDetails.quickCommerce.confirmedPicker.imageUrl
                              ? helper.imageUrl + bookingDetails.quickCommerce.confirmedPicker.imageUrl
                              : helper.DefaultImages.DefaultUserImage
                          "
                          (error)="handleMerchantImageError($event)"
                          alt=""
                          class="avatar-xl rounded material-shadow border"
                        />
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <div class="d-flex flex-wrap mb-2">
                          <h6 class="fs-14 mb-0">{{ bookingDetails.quickCommerce.confirmedPicker.name }}</h6>
                        </div>
                        <p class="text-muted mb-2">#{{ bookingDetails.quickCommerce.confirmedPicker.uniqueId }}</p>
                        @if (bookingDetails.quickCommerce.confirmedPicker.email) {
                        <div class="mb-2"><em class="ri-mail-line me-2 align-middle text-muted fs-16"></em>{{ bookingDetails.quickCommerce.confirmedPicker.email }}</div>
                        }
                        <div class="mb-2"><em class="ri-phone-line me-2 align-middle text-muted fs-16"></em>{{ bookingDetails.quickCommerce.confirmedPicker.phone }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                }
                <!-- picker details end -->

                <!-- driver details start -->
                @if (bookingDetails.confirmedDriver?.id) {
                <div class="">
                  <div class="bg-sub-gray d-flex justify-content-between align-items-center py-2 column-padding">
                    <h5 class="mb-0">{{ "heading-title.driver-details" | translate }}</h5>
                  </div>
                  <div class="column-padding py-3">
                    <div class="d-flex align-items-center mb-3">
                      <div class="flex-shrink-0">
                        <img
                          [src]="bookingDetails.confirmedDriver.imageUrl ? helper.imageUrl + bookingDetails.confirmedDriver.imageUrl : helper.DefaultImages.DefaultUserImage"
                          (error)="handleDriverImageError($event)"
                          alt=""
                          class="avatar-xl rounded material-shadow border"
                        />
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <div class="d-flex flex-wrap mb-2">
                          <h6 class="fs-14 mb-0">{{ bookingDetails.confirmedDriver.name }}</h6>
                          @if (bookingDetails?.rating?.customerRate) {
                          <div class="badge bg-success mb-0 ms-2" style="height: fit-content"><em class="mdi mdi-star"></em> {{ bookingDetails?.rating?.customerRate }}</div>
                          }
                        </div>
                        <p class="text-muted mb-2">#{{ bookingDetails.confirmedDriver.uniqueId }}</p>
                        @if (bookingDetails.confirmedDriver.email) {
                        <div class="mb-2"><em class="ri-mail-line me-2 align-middle text-muted fs-16"></em>{{ bookingDetails.confirmedDriver.email }}</div>
                        } @if (bookingDetails.confirmedDriver.phone) {
                        <div class="mb-2"><em class="ri-phone-line me-2 align-middle text-muted fs-16"></em>{{ bookingDetails.confirmedDriver.phone }}</div>
                        } @if (bookingDetails.confirmedDriver.vehicleDetail && !isServiceBooking()) {
                        <p class="mb-2">
                          <em class="ri-taxi-fill me-2 align-middle text-muted fs-16"></em>
                          {{ bookingDetails.confirmedDriver.vehicleDetail.brand }} | {{ bookingDetails.confirmedDriver.vehicleDetail.model }} |
                          {{ bookingDetails.confirmedDriver.vehicleDetail.color }} | {{ bookingDetails.confirmedDriver.vehicleDetail.plateNo }}
                        </p>
                        }
                      </div>
                    </div>

                    <!-- driver partner details start -->
                    @if (bookingDetails.partner) {
                    <div class="">
                      <p class="text-muted mb-2">{{ "label-title.partner-details" | translate }}</p>
                      <h6 class="fs-14 mb-2">{{ bookingDetails.partner?.firstName }} {{ bookingDetails.partner?.lastName }}</h6>
                      <p class="text-muted mb-0">{{ bookingDetails.partner?.email }}</p>
                    </div>
                    }
                    <!-- driver partner details end -->
                  </div>
                </div>
                }
                <!-- driver details end -->

                @if (bookingDetails.customerNote || bookingSpeakingLanguages.length > 0) {
                <div class="">
                  <div class="bg-sub-gray d-flex justify-content-between align-items-center py-2 column-padding">
                    <h5 class="mb-0">{{ "heading-title.other-details" | translate }}</h5>
                  </div>

                  <!-- customer note start -->
                  @if (bookingDetails.customerNote) {
                  <div class="column-padding py-3 border-bottom d-flex">
                    <p class="col-6 mb-2">{{ "label-title.customer-note" | translate }}</p>
                    <p class="col-6 mb-2">{{ bookingDetails.customerNote }}</p>
                  </div>
                  }
                  <!-- customer note end -->

                  <!-- speaking languages start -->
                  @if (bookingSpeakingLanguages.length > 0) {
                  <div class="column-padding py-3 border-bottom">
                    <h6 class="mb-3">{{ "heading-title.speaking-languages" | translate }}</h6>

                    @for (language of bookingSpeakingLanguages; track $index) {
                    <p class="mb-0">{{ $index + 1 }}. {{ language }}</p>
                    }
                  </div>
                  }
                  <!-- speaking languages end -->

                  <!-- <div class="column-padding py-3">
                    <h6 class="mb-3">{{ "heading-title.gender-preference" | translate }}</h6>
                  </div> -->
                </div>
                }
              </div>

              <div class="col-lg-3 col-md-6 col-12 border-end border-bottom px-0">
                <!-- Accessibility start -->
                @if (bookingDetails.accessibilityIds?.length > 0) {
                <div class="">
                  <div class="bg-sub-gray d-flex justify-content-between align-items-center py-2 column-padding">
                    <h5 class="mb-0">{{ "heading-title.accessibility" | translate }}</h5>
                  </div>
                  <div class="column-padding py-3">
                    @if (bookingDetails.accessibilityNamesArray?.length > 0) { @for (name of bookingDetails.accessibilityNamesArray; track $index) {
                    <p [ngClass]="{ 'mb-2': $index !== bookingDetails.accessibilityNamesArray.length - 1, 'mb-0': $index === bookingDetails.accessibilityNamesArray.length - 1 }">
                      {{ name | translatedName : helper.cuurentLang }}
                    </p>
                    } }
                  </div>
                </div>
                }
                <!-- Accessibility end -->

                <!-- Device Info start -->
                <div class="">
                  <div class="bg-sub-gray d-flex justify-content-between align-items-center py-2 column-padding">
                    <h5 class="mb-0">{{ "heading-title.device-info" | translate }}</h5>
                  </div>
                  <div class="">
                    <!-- Book From start -->
                    @if (bookingDetails.createdDeviceInfo) {
                    <div class="column-padding py-3">
                      <h6 class="mb-3">{{ "heading-title.book-from" | translate | uppercase }}</h6>
                      <div class="d-flex">
                        <p class="col-6 mb-2">{{ "label-title.id" | translate }}</p>
                        <p class="col-6 mb-2">{{ bookingDetails.createdDeviceInfo.deviceId ? bookingDetails.createdDeviceInfo.deviceId : "-" }}</p>
                      </div>
                      <div class="d-flex">
                        <p class="col-6 mb-2">{{ "label-title.name" | translate }}</p>
                        <p class="col-6 mb-2">{{ bookingDetails.createdDeviceInfo.deviceName ? bookingDetails.createdDeviceInfo.deviceName : "-" }}</p>
                      </div>
                      <div class="d-flex">
                        <p class="col-6 mb-2">{{ "label-title.manufacturer" | translate }}</p>
                        <p class="col-6 mb-2">{{ bookingDetails.createdDeviceInfo.manufacturer ? bookingDetails.createdDeviceInfo.manufacturer : "-" }}</p>
                      </div>
                      <div class="d-flex">
                        <p class="col-6 mb-2">{{ "label-title.type" | translate }}</p>
                        <p class="col-6 mb-2">{{ bookingDetails.createdDeviceInfo.deviceType ? bookingDetails.createdDeviceInfo.deviceType : "-" }}</p>
                      </div>
                      <div class="d-flex">
                        <p class="col-6 mb-2">{{ "label-title.os" | translate }}</p>
                        <p class="col-6 mb-2">{{ bookingDetails.createdDeviceInfo.os ? bookingDetails.createdDeviceInfo.os : "-" }}</p>
                      </div>
                      <div class="d-flex">
                        <p class="col-6 mb-0">{{ "label-title.app-version" | translate }}</p>
                        <p class="col-6 mb-0">{{ bookingDetails.createdDeviceInfo.appVersion ? bookingDetails.createdDeviceInfo.appVersion : "-" }}</p>
                      </div>
                    </div>
                    }
                    <!-- Book From end -->

                    <!-- Complete From start -->
                    @if (bookingDetails.confirmedDriver?.deviceInfo?.typeIds?.length > 0) {
                    <div class="column-padding border-top py-3">
                      <h6 class="mb-3">
                        @if(isQuickCommerceBooking() || isDeliveryBooking() || isServiceBooking()) {
                        {{ "heading-title.driver" | translate | uppercase }}
                        } @else if (bookingDetails.status >= helper.BookingStatus.ARRIVED_AT_DESTINATION) {
                        {{ "heading-title.complete-from" | translate | uppercase }}
                        } @else {
                        {{ "heading-title.accept-from" | translate | uppercase }}
                        }
                      </h6>
                      <div class="d-flex">
                        <p class="col-6 mb-2">{{ "label-title.id" | translate }}</p>
                        <p class="col-6 mb-2">{{ bookingDetails.confirmedDriver?.deviceInfo?.deviceId ? bookingDetails.confirmedDriver?.deviceInfo?.deviceId : "-" }}</p>
                      </div>
                      <div class="d-flex">
                        <p class="col-6 mb-2">{{ "label-title.name" | translate }}</p>
                        <p class="col-6 mb-2">{{ bookingDetails.confirmedDriver?.deviceInfo?.deviceName ? bookingDetails.confirmedDriver?.deviceInfo?.deviceName : "-" }}</p>
                      </div>
                      <div class="d-flex">
                        <p class="col-6 mb-2">{{ "label-title.manufacturer" | translate }}</p>
                        <p class="col-6 mb-2">{{ bookingDetails.confirmedDriver?.deviceInfo?.manufacturer ? bookingDetails.confirmedDriver?.deviceInfo?.manufacturer : "-" }}</p>
                      </div>
                      <div class="d-flex">
                        <p class="col-6 mb-2">{{ "label-title.type" | translate }}</p>
                        <p class="col-6 mb-2">{{ bookingDetails.confirmedDriver?.deviceInfo?.deviceType ? bookingDetails.confirmedDriver?.deviceInfo?.deviceType : "-" }}</p>
                      </div>
                      <div class="d-flex">
                        <p class="col-6 mb-2">{{ "label-title.os" | translate }}</p>
                        <p class="col-6 mb-2">{{ bookingDetails.confirmedDriver?.deviceInfo?.os ? bookingDetails.confirmedDriver?.deviceInfo?.os : "-" }}</p>
                      </div>
                      <div class="d-flex">
                        <p class="col-6 mb-0">{{ "label-title.app-version" | translate }}</p>
                        <p class="col-6 mb-0">{{ bookingDetails.confirmedDriver?.deviceInfo?.appVersion ? bookingDetails.confirmedDriver?.deviceInfo?.appVersion : "-" }}</p>
                      </div>
                    </div>
                    }
                    <!-- Complete From end -->
                  </div>
                </div>
                <!-- Device Info end -->

                <!-- Referal Details start -->
                @if (bookingDetails?.bookingInvoice?.refundDetail?.other > 0 || bookingDetails?.bookingInvoice?.refundDetail?.wallet > 0) {
                <div class="">
                  <div class="bg-sub-gray d-flex justify-content-between align-items-center py-2 column-padding">
                    <h5 class="mb-0">{{ "heading-title.refund-details" | translate }}</h5>
                  </div>
                  <div class="column-padding py-3">
                    <div class="d-flex">
                      <p class="col-6 mb-2">{{ "label-title.wallet" | translate }}</p>
                      <p class="col-6 mb-2">
                        <span class="d-flex currency-gap">
                          {{ bookingDetails?.bookingInvoice?.refundDetail?.wallet?.toFixed(decimalPointValue) }}
                          <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                            {{ bookingDetails.bookingInvoice?.currencySign }}
                          </span>
                        </span>
                      </p>
                    </div>

                    <div class="d-flex">
                      <p class="col-6 mb-2">{{ "label-title.other" | translate }}</p>
                      <p class="col-6 mb-2">
                        <span class="d-flex currency-gap">
                          {{ bookingDetails?.bookingInvoice?.refundDetail?.other?.toFixed(decimalPointValue) }}
                          <span [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                            {{ bookingDetails.bookingInvoice?.currencySign }}
                          </span>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                }
                <!-- Referal Details end -->

                <!-- Emergency contact History start -->
                @if (bookingDetails?.emergencyContactsHistory?.customer?.length > 0 || bookingDetails?.emergencyContactsHistory?.driver?.length > 0) {
                <div class="">
                  <div class="bg-sub-gray d-flex justify-content-between align-items-center py-2 column-padding">
                    <h5 class="mb-0">{{ "heading-title.emergency-contact-history" | translate }}</h5>
                  </div>
                  @if(bookingDetails?.emergencyContactsHistory?.customer?.length > 0){
                  <div class="column-padding py-3">
                    <h6 class="mb-3">{{ "heading-title.customer" | translate | uppercase }}</h6>
                    @for (customer of bookingDetails?.emergencyContactsHistory?.customer; track $index) {
                    <div class="col-12">
                      {{ customer }}
                    </div>
                    }
                  </div>
                  } @if(bookingDetails?.emergencyContactsHistory?.driver?.length > 0){
                  <div class="column-padding border-top py-3">
                    <h6 class="mb-3">{{ "heading-title.driver" | translate | uppercase }}</h6>
                    @for (driver of bookingDetails?.emergencyContactsHistory?.driver; track $index) {
                    <div class="col-12">
                      {{ driver }}
                    </div>
                    }
                  </div>
                  }
                </div>
                }
                <!-- Emergency contact History end -->
              </div>

              <div class="col-lg-5 col-12 border-end border-bottom px-0">
                <div [ngClass]="isQuickCommerceBooking() || isDeliveryBooking() || isServiceBooking() ? '' : 'p-3'">
                  @if (isQuickCommerceBooking() || isDeliveryBooking() || isServiceBooking()) {
                  <!-- cart details start -->
                  @if (bookingDetails.cart) {
                  <app-booking-cart-details [bookingDetails]="bookingDetails"></app-booking-cart-details>
                  }
                  <!-- cart details end -->
                  } @else {
                  <!-- Map start -->
                  <div id="bookingDetailsMap" class="booking-details-map mb-4"></div>
                  <div id="legend" [hidden]="helper.mapTypeMapBox()"></div>
                  <!-- Map end -->
                  }

                  <!-- Address details start -->
                  <div [ngClass]="isQuickCommerceBooking() || isDeliveryBooking() || isServiceBooking() ? 'd-flex p-3 border-top' : 'row'">
                    <div class="col-6" [ngClass]="{ 'column-padding': isQuickCommerceBooking() || isDeliveryBooking() || isServiceBooking() }">
                      <div class="border h-100">
                        <div class="p-3 border-bottom">
                          <h5 class="mb-0">
                            <img [src]="helper.MapPinImages.PickupMapPin" alt="pick-up-pin" class="map-pin-height" />
                            {{ "heading-title.pickup-address" | translate }}
                          </h5>
                        </div>
                        <div class="p-3">
                          <p class="mb-0 d-flex">
                            {{ bookingDetails.pickupAddress?.address }}
                          </p>
                          @if(bookingDetails.pickupAddress?.metadata?.length){
                          <div class="d-flex flex-column">
                            @for (item of bookingDetails.pickupAddress?.metadata; track item.key) {
                            <small class="text-muted"
                              ><b>{{ item.key }}:</b> {{ item.value }}</small
                            >
                            }
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                    @if (!isDeliveryPickUpBooking()) {
                    <!-- show destination if not pickup delivery order -->
                    @if (bookingDetails.status >= helper.BookingStatus.ARRIVED_AT_DESTINATION && bookingDetails.actualDestinationAddresses?.length > 0) {
                    @if(bookingDetails.actualDestinationAddresses?.length > 0) {
                    <div class="col-6" [ngClass]="{ 'column-padding': isQuickCommerceBooking() || isDeliveryBooking() || isServiceBooking() }">
                      <div class="border h-100">
                        <div class="p-3 border-bottom">
                          <h5 class="mb-0 d-flex justify-content-between align-items-center gap-1">
                            <div class="d-flex">
                              <img [src]="helper.MapPinImages.DestinationMapPin" alt="destination-pin" class="map-pin-height" />
                              {{ "heading-title.destination-address" | translate }}
                            </div>
                            @if ((isQuickCommerceBooking() || isDeliveryBooking() || isServiceBooking()) && bookingDetails.status < helper.BookingStatus.ARRIVED_AT_DESTINATION) {
                            <a href="javascript:void(0);" class="btn btn-sm btn-secondary" style="padding: 0px 10px" appClickHoverTooltip="map-view" (click)="showMap()">
                              <em class="ri-road-map-line fs-18"></em>
                            </a>
                            }
                          </h5>
                        </div>
                        <div class="p-3">
                          <p class="mb-0 d-flex">
                            {{ bookingDetails.actualDestinationAddresses[bookingDetails.actualDestinationAddresses.length - 1]?.address }}
                          </p>
                          @if(bookingDetails.actualDestinationAddresses[bookingDetails.actualDestinationAddresses.length - 1]?.metadata?.length){
                          <div class="d-flex flex-column">
                            @for (item of bookingDetails.actualDestinationAddresses[bookingDetails.actualDestinationAddresses.length - 1]?.metadata; track item.key) {
                            <small class="text-muted"
                              ><b>{{ item.key }}:</b> {{ item.value }}</small
                            >
                            }
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                    } @if (bookingDetails.actualDestinationAddresses?.length > 1) { @for (stop of bookingDetails.actualDestinationAddresses; track $index) { @if ($index !=
                    bookingDetails.actualDestinationAddresses.length - 1) {
                    <div class="col-6 mt-3" [ngClass]="{ 'column-padding': isQuickCommerceBooking() || isDeliveryBooking() || isServiceBooking() }">
                      <div class="border h-100">
                        <div class="p-3 border-bottom">
                          <h5 class="mb-0">
                            <img [src]="helper.MapPinImages.StopMapPin" alt="stop-pin" class="map-pin-height" />
                            {{ "heading-title.stop-address" | translate }} {{ $index + 1 }}
                          </h5>
                        </div>
                        <div class="p-3">
                          <p class="mb-0 d-flex">
                            {{ stop.address }}
                          </p>
                          <div class="d-flex flex-column" *ngIf="stop.metadata?.length">
                            @for (item of stop.metadata; track item.key) {
                            <small class="text-muted"
                              ><b>{{ item.key }}:</b> {{ item.value }}</small
                            >
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    } } } } @else { @if (bookingDetails.destinationAddresses?.length > 0) {
                    <div class="col-6" [ngClass]="{ 'column-padding': isQuickCommerceBooking() || isDeliveryBooking() || isServiceBooking() }">
                      <div class="border h-100">
                        <div class="p-3 border-bottom">
                          <h5 class="mb-0 d-flex justify-content-between align-items-center gap-1">
                            <div class="d-flex">
                              <img [src]="helper.MapPinImages.DestinationMapPin" alt="destination-pin" class="map-pin-height" />
                              {{ "heading-title.destination-address" | translate }}
                            </div>
                            @if ((isQuickCommerceBooking() || isDeliveryBooking()|| isServiceBooking()) && bookingDetails.status < helper.BookingStatus.ARRIVED_AT_DESTINATION) {
                            <a href="javascript:void(0);" class="btn btn-sm btn-secondary" style="padding: 0px 10px" appClickHoverTooltip="map-view" (click)="showMap()">
                              <em class="ri-road-map-line fs-18"></em>
                            </a>
                            }
                          </h5>
                        </div>
                        <div class="p-3">
                          <p class="mb-0 d-flex">
                            {{ bookingDetails.destinationAddresses[bookingDetails.destinationAddresses.length - 1]?.address }}
                          </p>
                          @if(bookingDetails.destinationAddresses[bookingDetails.destinationAddresses.length - 1]?.metadata?.length){
                          <div class="d-flex flex-column">
                            @for (item of bookingDetails.destinationAddresses[bookingDetails.destinationAddresses.length - 1]?.metadata; track item.key) {
                            <small class="text-muted"
                              ><b>{{ item.key }}:</b> {{ item.value }}</small
                            >
                            }
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                    } @if (bookingDetails.destinationAddresses.length > 1) { @for (stop of bookingDetails.destinationAddresses; track $index) { @if ($index !=
                    bookingDetails.destinationAddresses.length - 1) {
                    <div class="col-6 mt-3" [ngClass]="{ 'column-padding': isQuickCommerceBooking() || isDeliveryBooking() || isServiceBooking() }">
                      <div class="border h-100">
                        <div class="p-3 border-bottom">
                          <h5 class="mb-0">
                            <img [src]="helper.MapPinImages.StopMapPin" alt="stop-pin" class="map-pin-height" />
                            {{ "heading-title.stop-address" | translate }} {{ $index + 1 }}
                          </h5>
                        </div>
                        <div class="p-3">
                          <p class="mb-0 d-flex">
                            {{ stop.address }}
                          </p>
                          <div class="d-flex flex-column" *ngIf="stop.metadata?.length">
                            @for (item of stop.metadata; track item.key) {
                            <small class="text-muted"
                              ><b>{{ item.key }}:</b> {{ item.value }}</small
                            >
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    } } } }
                    <!--  -->
                    }
                  </div>
                </div>
                <!-- Address details end -->
              </div>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink (click)="onTabClick('invoice')">
            {{ "label-title.estimated-invoice" | translate }}
          </a>
          <ng-template ngbNavContent>
            <app-booking-invoice
              [bookingDetails]="bookingDetails"
              [accessibilityList]="accessibilityList"
              [customPrices]="customPrices"
              [bookingTimezone]="bookingTimezone"
              [bookingHistoryMainType]="bookingHistoryMainType"
              [isShowEstimatedInvoice]="true"
              [invoiceType]="'estimated'"
            ></app-booking-invoice>
          </ng-template>
        </li>
        <li [ngbNavItem]="9">
          <a ngbNavLink (click)="onTabClick('payment')">{{ "label-title.payment" | translate }}</a>
          <ng-template ngbNavContent>
            @if (tripPayment(); as pay) {
            <div class="trip-payment" id="trip-payment">
              <h3>{{ pay.source }}</h3>
              <div class="trip-pay-card">
                <div class="trip-pay-row">
                  <span>Method</span>
                  <b id="trip-pay-method">{{ pay.method }}</b>
                </div>
                @if (pay.split) {
                <div class="trip-pay-row">
                  <span>Split</span>
                  <b id="trip-pay-split">{{ pay.split }}</b>
                </div>
                }
                <div class="trip-pay-row">
                  <span>Status</span>
                  <b><span id="trip-pay-status" class="trip-pay-status" [ngClass]="pay.statusTone">{{ pay.status }}</span></b>
                </div>
              </div>

              <h3>Fare</h3>
              <div class="trip-pay-card">
                @for (line of pay.lines; track line.id) {
                <div class="trip-pay-row" [class.discount]="line.discount" [class.total]="line.total">
                  <span>{{ line.label }}</span>
                  <b [id]="line.id">{{ line.text }}</b>
                </div>
                }
              </div>

              <!-- Card block only on a card rail. A cash, wallet, account or voucher trip has no
                   intent and no last 4, and showing the rows empty just reads as missing data. -->
              @if (pay.isCard) {
              <h3>Card</h3>
              <div class="trip-pay-card">
                <div class="trip-pay-row">
                  <span>Stripe payment intent</span>
                  <b id="trip-pay-intent">{{ pay.intent }}</b>
                </div>
                <div class="trip-pay-row">
                  <span>Card last 4</span>
                  <b id="trip-pay-last4">{{ pay.last4 }}</b>
                </div>
              </div>
              }

              <h3>Driver payout</h3>
              <div class="trip-pay-card">
                <div class="trip-pay-row">
                  <span>Driver share</span>
                  <b id="trip-pay-payout">{{ pay.payout }}</b>
                </div>
                @for (note of pay.payoutNotes; track note) {
                <div class="trip-pay-row">
                  <span class="trip-pay-muted">{{ note }}</span>
                </div>
                }
              </div>

              <h3>Refund history</h3>
              <div class="trip-pay-card" id="trip-pay-refunds">
                @if (pay.refunds.length) {
                @for (refund of pay.refunds; track $index) {
                <div class="trip-pay-row">
                  <span>{{ refund.label }}@if (refund.detail) { <span class="trip-pay-muted"> · {{ refund.detail }}</span> }</span>
                  <b>{{ refund.amount }}</b>
                </div>
                }
                } @else {
                <div class="trip-pay-row">
                  <span id="trip-pay-refund-empty">No refunds on this trip.</span>
                </div>
                }
              </div>
            </div>
            } @else {
            <div class="trip-payment" id="trip-payment">
              <p id="trip-pay-empty">Payment details were not returned for this trip.</p>
            </div>
            }
          </ng-template>
        </li>
        <li [ngbNavItem]="4">
          <a ngbNavLink (click)="onTabClick('activities')">{{ "label-title.activities" | translate }}</a>
          <ng-template ngbNavContent>
            <div class="row m-0 justify-content-center">
              <div class="col-lg-6 py-3">
                <div>
                  <div class="timeline booking-status-timeline" style="max-width: unset; margin: 0">
                    @for (statusTimeline of bookingStatusTimeline; track $index) {
                    <div class="timeline-item left">
                      <div
                        class="timeline-date icon"
                        [ngClass]="{
                          'timeline-date-danger': [
                            helper.BookingStatus.BID_NOT_ANSWERED,
                            helper.BookingStatus.BID_REJECTED,
                            helper.BookingStatus.CANCELLED,
                            helper.BookingStatus.NOT_ANSWERED,
                            helper.BookingStatus.NO_DRIVER_FOUND,
                            helper.BookingStatus.REJECTED,
                            helper.BookingStatus.PICKER_REJECTED,
                            helper.BookingStatus.PICKER_NOT_ANSWERED,
                            helper.BookingStatus.NO_PICKER_FOUND,
                            helper.BookingStatus.MERCHANT_REJECTED
                          ].includes(statusTimeline.status)
                        }"
                      ></div>
                      <div class="date text-nowrap">
                        {{ helper.moment(statusTimeline.time).tz(bookingTimezone).format(helper.DATE_FORMAT.DD_MM_YY) }}
                        {{
                          helper
                            .moment(statusTimeline.time)
                            .tz(bookingTimezone)
                            .format(bookingDetails.timeFormat ?? helper.TimeFormatEnum.TwentyFourHour)
                        }}
                      </div>
                      <div class="content mt-4">
                        <h5 class="mb-0">
                          {{ getStatusString(statusTimeline.status) | translate }}
                        </h5>
                        @if (statusTimeline.name){
                        <h6 class="mb-0 mt-2">
                          @if (statusTimeline.type) {
                          <span> {{ "label-title.by" | translate | titlecase }} {{ helper.UserTypeString[statusTimeline.type] | translate }} : </span>
                          }
                          {{ statusTimeline.name }}
                        </h6>
                        } @if (statusTimeline.extraData?.name){
                        <p class="mb-0 mt-1">{{ "label-title.item" | translate }} : {{ statusTimeline.extraData?.name | translatedName : helper.cuurentLang }}</p>
                        } @if (statusTimeline.note){
                        <p class="mb-0 mt-2">{{ "label-title.note" | translate }} : {{ statusTimeline.note }}</p>
                        } @if (statusTimeline.rate) {
                        <div class="d-flex align-items-end mt-2">
                          <p class="mb-0">
                            {{ "label-title.rating" | translate }} :
                            <span class="star-rating">
                              @for(star of [].constructor(statusTimeline.rate); track $index) {
                              <i-feather name="star" class="text-secondary rate-dimension"></i-feather>
                              } @for(star of [].constructor(5 - statusTimeline.rate); track $index) {
                              <i-feather name="star" class="text-muted rate-dimension"></i-feather>
                              }
                            </span>
                          </p>
                        </div>
                        } @if (bookingDetails.cancellationReason && [helper.BookingStatus.CANCELLED,helper.BookingStatus.MERCHANT_REJECTED].includes(statusTimeline.status)) {
                        <p class="mb-0 mt-2">{{ "label-title.reason" | translate }} : {{ bookingDetails.cancellationReason }}</p>
                        }
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>

              <!-- Logs used to be their own tab. An operator reading a trip wants the status
                   timeline and the change log together, in one scroll, so the log sits under the
                   timeline here and tab 7 is gone. -->
              <div class="col-lg-6 py-3 booking-logs">
                <app-trip-log-timeline [trip]="bookingDetails"></app-trip-log-timeline>
              </div>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="5">
          <a ngbNavLink (click)="onTabClick('chat')">{{ "label-title.chat" | translate }}</a>
          <ng-template ngbNavContent>
            <ul
              ngbNav
              #Bordered="ngbNav"
              [(activeId)]="chatActiveTab"
              class="nav nav-tabs nav-tabs-custom nav-secondary mb-0 thead-sticky pt-3"
              id="tab-height"
              style="background-color: transparent !important; z-index: 1"
            >
              @if (bookingDetails?.confirmedDriver?.id) {
              <li [ngbNavItem]="1">
                <a ngbNavLink (click)="onChatTabClick(this.helper.ChatType.CUSTOMER_DRIVER_CHAT)">{{ "label-title.customer-driver-chat" | translate }}</a>
                <ng-template ngbNavContent>
                  <app-chat [bookingDetails]="bookingDetails" [bookingTimezone]="bookingTimezone" [chatType]="helper.ChatType.CUSTOMER_DRIVER_CHAT"></app-chat>
                </ng-template>
              </li>
              <!-- Customer/merchant chat removed: a dispatcher works rides and tows, and that thread
                   is between the rider and a store. Driver/merchant is kept for the delivery flow. -->
              } @if (bookingDetails?.confirmedDriver?.id && bookingDetails?.quickCommerce?.merchantDetail?.id) {
              <li [ngbNavItem]="3">
                <a ngbNavLink (click)="onChatTabClick(this.helper.ChatType.DRIVER_MERCHANT_CHAT)">{{ "label-title.driver-merchant-chat" | translate }}</a>
                <ng-template ngbNavContent>
                  <app-chat [bookingDetails]="bookingDetails" [bookingTimezone]="bookingTimezone" [chatType]="helper.ChatType.DRIVER_MERCHANT_CHAT"></app-chat>
                </ng-template>
              </li>
              }
            </ul>
            <div class="tab-content text-muted">
              <div [ngbNavOutlet]="Bordered"></div>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="8">
          <a ngbNavLink id="booking-tab-track" (click)="onTabClick('vehicleTrack')">Vehicle Track</a>
          <ng-template ngbNavContent>
            <app-trip-vehicle-track [booking]="bookingDetails" [bookingId]="bookingId"></app-trip-vehicle-track>
          </ng-template>
        </li>
        @if ( bookingDetails.status >= helper.BookingStatus.ARRIVED_AT_DESTINATION) {
        <li [ngbNavItem]="3">
          <a ngbNavLink (click)="onTabClick('invoice')">
            {{ "label-title.invoice" | translate }}
          </a>
          <ng-template ngbNavContent>
            <app-booking-invoice
              [bookingDetails]="bookingDetails"
              [accessibilityList]="accessibilityList"
              [customPrices]="customPrices"
              [bookingTimezone]="bookingTimezone"
              [bookingHistoryMainType]="bookingHistoryMainType"
              [isShowEstimatedInvoice]="false"
              [invoiceType]="'actual'"
            ></app-booking-invoice>
          </ng-template>
        </li>
        }
        <li [ngbNavItem]="6" *ngIf="bookingDetails?.bookingType === helper.BookingType.TOWING">
          <a ngbNavLink>{{ "label-title.towing-questions" | translate }}</a>
          <ng-template ngbNavContent>
            <div class="row booking-details-tab-content-height" style="margin-left: 0; margin-right: 0">
              <div class="col-12 px-0">

                @if (bookingDetails?.questions?.length > 0) {
                  <div class="column-padding py-3">
                    <div class="row g-3">

                      @for (question of bookingDetails.questions; track question.questionId) {

                        <!-- IMAGE type - full width -->
                        @if (question.questionType === 'IMAGE') {
                          <div class="col-12">
                            <div class="card mb-0 border shadow-none">
                              <div class="card-body p-3">
                                <div class="d-flex align-items-center gap-2 mb-3">
                                  <div class="avatar-xs flex-shrink-0">
                                    <span class="avatar-title bg-soft-primary text-primary rounded fs-16">
                                      <em class="ri-image-line"></em>
                                    </span>
                                  </div>
                                  <div>
                                    <h6 class="mb-0 fs-14">{{ question.questionText }}</h6>
                                    <span class="badge bg-soft-info text-info fs-10 mt-1">{{ question.questionType | titlecase }}</span>
                                  </div>
                                </div>
                                <div class="d-flex flex-wrap gap-2">
                                  @for (imgPath of question.answer; track $index) {
                                    <div
                                      class="position-relative rounded border overflow-hidden"
                                      style="width: 110px; height: 110px; cursor: pointer;"
                                      (click)="openImagePreview(helper.imageUrl + imgPath)"
                                    >
                                      <img
                                        [src]="helper.imageUrl + imgPath"
                                        (error)="handleImageError($event)"
                                        alt="Image {{ $index + 1 }}"
                                        class="w-100 h-100"
                                        style="object-fit: cover;"
                                      />
                                      <div
                                        class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                        style="background: rgba(0,0,0,0); transition: background 0.2s;"
                                        onmouseenter="this.style.background='rgba(0,0,0,0.3)'"
                                        onmouseleave="this.style.background='rgba(0,0,0,0)'"
                                      >
                                        <em class="ri-zoom-in-line text-white fs-20 opacity-0" style="transition: opacity 0.2s;"></em>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        }

                        <!-- SINGLE_OPTION, FREE_TEXT, NUMBER, MULTI_OPTION - half width -->
                        @if (question.questionType !== 'IMAGE') {
                          <div class="col-lg-6 col-12">
                            <div class="card mb-0 border shadow-none h-100">
                              <div class="card-body p-3">
                                <div class="d-flex align-items-center gap-2 mb-2">
                                  <div class="avatar-xs flex-shrink-0">

                                    @if (question.questionType === 'SINGLE_OPTION') {
                                      <span class="avatar-title bg-soft-success text-success rounded fs-16">
                                        <em class="ri-check-line"></em>
                                      </span>
                                    }
                                    @if (question.questionType === 'MULTI_OPTION') {
                                      <span class="avatar-title bg-soft-warning text-warning rounded fs-16">
                                        <em class="ri-list-check"></em>
                                      </span>
                                    }
                                    @if (question.questionType === 'FREE_TEXT') {
                                      <span class="avatar-title bg-soft-secondary text-secondary rounded fs-16">
                                        <em class="ri-text"></em>
                                      </span>
                                    }
                                    @if (question.questionType === 'NUMBER') {
                                      <span class="avatar-title bg-soft-danger text-danger rounded fs-16">
                                        <em class="ri-hashtag"></em>
                                      </span>
                                    }

                                  </div>
                                  <div>
                                    <h6 class="mb-0 fs-14">{{ question.questionText }}</h6>
                                    <span class="badge fs-10 mt-1"
                                      [ngClass]="{
                                        'bg-soft-success text-success': question.questionType === 'SINGLE_OPTION',
                                        'bg-soft-warning text-warning': question.questionType === 'MULTI_OPTION',
                                        'bg-soft-secondary text-secondary': question.questionType === 'FREE_TEXT',
                                        'bg-soft-danger text-danger': question.questionType === 'NUMBER'
                                      }"
                                    >
                                      {{ question.questionType | titlecase }}
                                    </span>
                                  </div>
                                </div>

                                <div class="border-top pt-2 mt-1">

                                  <!-- SINGLE_OPTION -->
                                  @if (question.questionType === 'SINGLE_OPTION') {
                                    <div class="d-flex align-items-center gap-2">
                                      <em class="ri-radio-button-line text-success fs-14"></em>
                                      <p class="mb-0 fs-14">{{ question.answer[0] }}</p>
                                    </div>
                                  }

                                  <!-- MULTI_OPTION -->
                                  @if (question.questionType === 'MULTI_OPTION') {
                                    <div class="d-flex flex-wrap gap-2">
                                      @for (ans of question.answer; track $index) {
                                        <span class="badge bg-soft-warning text-warning border border-warning fs-12 fw-normal px-2 py-1">
                                          {{ ans }}
                                        </span>
                                      }
                                    </div>
                                  }

                                  <!-- FREE_TEXT -->
                                  @if (question.questionType === 'FREE_TEXT') {
                                    <p class="mb-0 fs-14 text-muted fst-italic">"{{ question.answer[0] }}"</p>
                                  }

                                  <!-- NUMBER -->
                                  @if (question.questionType === 'NUMBER') {
                                    <div class="d-flex align-items-center gap-2">
                                      <h4 class="mb-0 text-danger fw-bold">{{ question.answer[0] }}</h4>
                                    </div>
                                  }

                                </div>
                              </div>
                            </div>
                          </div>
                        }

                      }
                    </div>
                  </div>

                } @else {
                  <div class="d-flex flex-column align-items-center justify-content-center py-5">
                    <div class="avatar-md mb-3">
                      <span class="avatar-title bg-soft-secondary text-secondary rounded-circle fs-24">
                        <em class="ri-question-line"></em>
                      </span>
                    </div>
                    <h6 class="text-muted mb-1">{{ "label-title.no-questions-found" | translate }}</h6>
                    <p class="text-muted fs-13 mb-0">{{ "label-title.no-towing-questions-have-been-submitted-for-this-booking" | translate }}</p>
                  </div>
                }

              </div>
            </div>
          </ng-template>
        </li>
      </ul>
      <div class="tab-content text-muted">
        <div [ngbNavOutlet]="Bordered"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #mapModal let-modal>
  <div class="modal-content">
    <div class="modal-header border-bottom">
      <h5 class="modal-title">
        {{ "heading-title.map" | translate }}
      </h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeMapModal()"></button>
    </div>
    <div class="modal-body">
      <!-- Map start -->
      <div id="bookingDetailsMap" class="booking-details-map mb-4"></div>
      <div id="legend" [hidden]="helper.mapTypeMapBox()"></div>
      <!-- Map end -->
    </div>
  </div>
</ng-template>
